import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../types/RootState.js";
import { initialState } from "./slice.js";

const selectDomain = (state: RootState) => state.useWaalaxyExtension || initialState;

export const getWaalaxyExtensionState = createSelector([selectDomain], (state) => state);
